import React, { useEffect } from "react";
import { HashLink as Link } from 'react-router-hash-link';
import { Button, Header } from "semantic-ui-react";
import { useStore } from "../../app/stores/store";
import "../Certificacion/Curso.css";
import ActualizacionModal from "./ActualizacionModal";
import InscripcionCodigo from "./InscripcionCodigo";
import PagoModal from "./PagoModal";
import logo from "./logoInapAzul.png"
import "./Login&Register.css"
import { Form, Checkbox } from 'semantic-ui-react'
import { string } from "yup/lib/locale";
import Swal from "sweetalert2";
import PagoModalPost from './PagoModalPost';
import PagoModalConvenio from "./PagoModalConvenio";

interface Props {
    userId: any,
    curso: any,
    nombreCurso: any,
    tipo: any,
    monto: any,
    codigoBanco: any
}

const modalTimer = () => {
    let timerInterval: any;
    Swal.fire({
        position: "center",
        title: 'Espere porfavor.',
        html: 'Estamos finalizando su proceso de inscripción.',
        timerProgressBar: true,
        allowOutsideClick: false,
        showConfirmButton: false,
        allowEscapeKey: false,
        willClose: () => {
            clearInterval(timerInterval)
        }
    }).then((result) => {
        if (result.dismiss === Swal.DismissReason.timer) {
        }
    })
}

export default function CodigoInstitucionalPost(props: Props) {
    const { InscriptionsStore, userStore: { user }, modalStore } = useStore();
    const { createInscription, update_SGPersonas } = InscriptionsStore;
    const [open, setOpen] = React.useState(false);
    const [inputOpen, setinputOpen] = React.useState(false);
    const [botonCodigo, setbotonCodigo] = React.useState(true);
    const [botonConfirmación, setbotonConfirmación] = React.useState("");
    const [value, setValue] = React.useState(undefined)

    function inputInscripcionCodigo() {
        var inpuIns = (document.getElementById("codigo") as HTMLInputElement).value;
        if (inpuIns.length > 1) {
            setbotonCodigo(false)
        } else {
            setbotonCodigo(true)
        }
    }

    return (
        <div className="contenedor_info contenedor_modalIns">

            <div className="modalInscripcion-head"> 
                <h2>Confirmación de Pre-inscripción</h2>
            </div>
            
            {/* <img src={logo} style={{width: "65px", height: "60px"}}></img> */}
            
            <div className="modalInscripcion-body">

                <p>Has seleccionado Pre-Inscribirte a:</p>
                <h1><q>{props.nombreCurso}</q></h1>
                <p>¿Cuentas con un código institucional?</p>

                <Form className="formInscripcion">
                    <Form.Group inline widths={"2"}>
                        <Form.Field>
                            <Checkbox
                                radio
                                label='No'
                                name='checkboxRadioGroup'
                                value='false'
                                checked={value === 'false'}
                                onChange={(e, data: any) => {
                                    setValue(data.value)
                                    setOpen(true)
                                    setinputOpen(false)
                                }}
                            />
                        </Form.Field>

                        <Form.Field>
                            <Checkbox
                                radio
                                label='Si'
                                name='checkboxRadioGroup'
                                value='true'
                                checked={value === 'true'}
                                onChange={(e, data: any) => {
                                    setValue(data.value)
                                    setOpen(true)
                                    setinputOpen(true)
                                }}
                            />
                        </Form.Field>
                    </Form.Group>
                </Form>

                <div className="modal-alert">
                    <p>Un código institucional es proporcionado cuando tu institución cancelará el costo total o parcial del curso.</p>
                </div>

            </div>
            <div className="modalIns-buttons">
                {open ?
                    <>
                        {inputOpen ?
                            <>
                                {/* <p>Ingresa el codigo institucional:</p> */}

                                <div className="codigo-ins-area">
                                    <input id="codigo" type="text" placeholder="Ingresa tu código institucional" onChange={inputInscripcionCodigo}></input>
                                </div>
                                
                                <Button color="green" id="inscripcionB" disabled={botonCodigo} className="butt-codigo" onClick={() => {
                                    modalStore.closeModal();
                                    const valorInput = (document.getElementById("codigo") as HTMLInputElement).value;
                                    update_SGPersonas(props.userId).then(async () => {
                                        if (InscriptionsStore.actualizado === true) {
                                            let newInscription = {
                                                appUserId: props.userId,
                                                codigoCursoId: props.curso,
                                                solicitud: props.tipo,
                                                codigoInstitucional: valorInput
                                            };  modalTimer();
                                            await createInscription(newInscription).then(() => {
                                                const divBoton = document.getElementById('indcripcion_boton');
                                                divBoton?.style.setProperty("pointer-events", "none");
                                                divBoton?.style.setProperty("opacity", "0.5");
                                                if (InscriptionsStore.inscrito === true) {
                                                    modalStore.openModal(
                                                        <PagoModalConvenio codigo={props.codigoBanco} arancel={props.monto} />, 'mini'
                                                    )
                                                }
                                            });
                                        } else {
                                            modalStore.openModal(

                                                <ActualizacionModal ruta={props.curso} />, 'mini'
                                            )
                                        }
                                    })
                                }}>
                                    Pre-Inscribirme con código
                                </Button>
                            </> :
                            <>
                                <Button color="green" className="butt-codigo" onClick={() => {
                                    modalStore.closeModal();
                                    update_SGPersonas(props.userId).then(() => {
                                        if (InscriptionsStore.actualizado === true) {
                                            let newInscription = {
                                                appUserId: props.userId,
                                                codigoCursoId: props.curso,
                                                solicitud: props.tipo,
                                                codigoInstitucional: ""
                                            };  modalTimer();
                                            createInscription(newInscription).then(() => {
                                                const divBoton = document.getElementById('indcripcion_boton');
                                                divBoton?.style.setProperty("pointer-events", "none");
                                                divBoton?.style.setProperty("opacity", "0.5");
                                                if (InscriptionsStore.inscrito === true) {
                                                    modalStore.openModal(
                                                        <PagoModalPost codigo={props.codigoBanco} arancel={props.monto} />, 'mini'
                                                    )
                                                }
                                            });
                                        } else {
                                            modalStore.openModal(
                                                <ActualizacionModal ruta={props.curso} />, 'mini')

                                        }
                                       
                                    })
                                }}>
                                    Pre-Inscribirme
                                </Button>
                            </>
                        }
                    </>
                    :
                    <>
                    </>
                }

                <Button color="red" onClick={() => {
                    modalStore.closeModal()
                }}>Cancelar
                </Button>
            </div>
        </div>
    )
}

